/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Why_Focus_DescInputs */

const en_landing_why_focus_desc = /** @type {(inputs: Landing_Why_Focus_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reduces the pixel shifts, colour changes and texture artifacts that pile up across repeated edits.`)
};

const zh_landing_why_focus_desc = /** @type {(inputs: Landing_Why_Focus_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`减少反复编辑中累积的像素偏移、色彩变化和纹理瑕疵。`)
};

/**
* | output |
* | --- |
* | "Reduces the pixel shifts, colour changes and texture artifacts that pile up across repeated edits." |
*
* @param {Landing_Why_Focus_DescInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_why_focus_desc = /** @type {((inputs?: Landing_Why_Focus_DescInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Why_Focus_DescInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_why_focus_desc(inputs)
	return zh_landing_why_focus_desc(inputs)
});
export { landing_why_focus_desc as "landing.why.focus_desc" }